var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import { WhiteLabel } from '@/models/WhiteLabel';
import { RolesEnum } from '@/items/Roles';
import { Component, Vue } from 'vue-property-decorator';
import CreateDialog from './CreateDialog/CreateDialog';
let Whitelabels = class Whitelabels extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Whitelabel';
        this.isCreating = false;
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    get canCreate() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get tableOptions() {
        return {
            name: {
                singular: 'Whitelabel',
                plural: 'Whitelabels',
            },
            headers: [
                {
                    text: 'Whitelabel',
                    value: 'domain',
                    transform: (domain, whiteLabel) => {
                        const label = domain ? `.${domain}` : whiteLabel.slug;
                        const isDefault = whiteLabel.slug === 'scooltool-ninja';
                        return isDefault ? `${label} <span style="color: #999;">(standaard)</span>` : label;
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'settings',
                    icon: 'settings',
                    action: (vm, whiteLabel) => {
                        this.$router.push({ name: 'admin.whitelabel', params: { id: whiteLabel.id } });
                    },
                },
            ],
            filters: [],
            model: new WhiteLabel(),
        };
    }
};
Whitelabels = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CreateDialog,
        },
    })
], Whitelabels);
export default Whitelabels;
